<template>
    <div class="session-wrap">
        <div class="session-list">
            <div class="empty" v-if="!isLoading && groupList.length == 0">
                <img class="empty-img" src="https://static5.yingsaidata.com/mip/img/6020423-bg_nothing.png" alt="" />
                <span>暂无历史记录</span>
            </div>
            <div class="group" v-if="!isLoading && groupList.length > 0" v-for="(list, idx) in groupList"
                :key="'key_' + idx">
                <div class="group-name">{{ list.name }}</div>
                <div :class="{
                    active: item.isActive || item.session_id == curSelectSession.session_id,
                    'is-edit': item.nameEditState == EnumChatName.isEdit,
                    row: item.nameEditState == EnumChatName.isNormal,
                    'is-hover': item.isHoverd,
                    'not-allow': item.isNotAllowed
                }" v-for="(item, index) in list.list" :key="'key_' + index" @click="sessionClick(item, index)"
                    @mouseenter="rowMouseEnter(item)" @mouseleave="rowMouseLeave(item)">
                    <template v-if="item.nameEditState == EnumChatName.isNormal">
                        <div class="txt">{{ item.session_name }}</div>
                        <div class="operate-btn">
                            <svg class="iconpark-icon edit" @click.stop="itemEdit(item)">
                                <use href="#icbianjimoren"></use>
                            </svg>
                            <a-popconfirm okText="确认" overlayClassName="chat-delete-buttons-1"
                                @confirm="deleteSession(item)">
                                <template #title>
                                    <div class="confirm-wrap">
                                        <div class="title">删除对话</div>
                                        <div class="cont">对话删除后将无法恢复，确认删除？</div>
                                    </div>
                                </template>
                                <svg class="iconpark-icon delete" @click.stop>
                                    <use href="#icshanchumoren"></use>
                                </svg>
                            </a-popconfirm>
                        </div>
                    </template>

                    <template v-if="item.nameEditState == EnumChatName.isEdit">
                        <input v-model="item.new_session_name" class="dialog-name ellipse name-input" />
                        <span class="edit-icon">
                            <svg class="quxiao iconpark-icon" @click.stop="editName(Editflag.cancel, item)">
                                <use href="#no"></use>
                            </svg>
                            <svg class="queren iconpark-icon" @click.stop="editName(Editflag.confirm, item)">
                                <use href="#ok"></use>
                            </svg>
                        </span>
                    </template>
                </div>
            </div>
        </div>
        <div class="to-left" @click="shrink">
            <svg class="iconpark-icon">
                <use href="#ichuihuajiluzhankai"></use>
            </svg>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useInfo, Editflag, EnumChatName } from './hook'

const props = defineProps({})

const {
    isShowHistory,
    groupList,
    sessionClick,
    shrink,
    curSelectSession,
    itemEdit,
    editName,
    deleteSession,
    rowMouseEnter,
    rowMouseLeave,
    isLoading
} = useInfo(props)
point(3, 1, {}, '历史会话侧边栏曝光即触发')
</script>

<style scoped lang="less">
.iconpark-icon {
    width: 16px;
    height: 16px;
    display: block;
}

.session-wrap {
    position: relative;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    display: flex;
    padding-left: 12px;

    .session-list {
        transition: all 0.3s;
        height: 545px;
        width: 223px;
        overflow-y: hidden;
        background: #ffffff;
        border-radius: 16px;
        box-sizing: border-box;
        padding: 8px;

        // position: relative;
        .group-name {
            color: rgba(0, 0, 0, 0.4);
            font-size: 12px;
            margin-bottom: 4px;
        }

        .row {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0 10px;
            position: relative;
            margin: 4px 0;
            overflow: hidden;

            .txt {
                font-size: 12px;
                color: #333333;
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                height: 30px;
                line-height: 30px;
                // padding: 7px 0;
            }

            &.active.row {
                background: #f3f5fa;
                border-radius: 242px;
            }

            &.is-hover {
                background: #f3f5fa;
                border-radius: 242px;

                .operate-btn {
                    display: flex;
                }
            }

            &.not-allow {
                cursor: not-allowed;
            }

            .operate-btn {
                display: none;
                position: absolute;
                right: 0;
                padding-right: 12px;
                align-items: center;
                background: #f3f5fa;
                padding-left: 12px;

                .edit {
                    margin-right: 8px;
                }
            }
        }

        .is-edit {
            display: flex;
            height: 30px;
            align-items: center;
            border-radius: 16px;
            background: #ffffff;
            border: 1px solid @primary-color;
            box-sizing: border-box;
            padding: 0 8px;
            margin: 4px 0;

            .name-input {
                padding: 0 8px 0 0;
                color: rgba(0, 0, 0, 0.9);
                font-size: 12px;
                border-radius: 2px;
                outline: none;
                caret-color: @primary-color;
                height: 24px;
                flex: 1;

                line-height: 20px;
            }

            .edit-icon {
                display: flex;

                .iconpark-icon {
                    cursor: pointer;

                    &:hover {
                        color: @primary-color;
                    }
                }

                .quxiao {
                    margin-right: 8px;
                }
            }
        }

        &:hover {
            overflow-y: auto;
        }
    }

    .to-left {
        cursor: pointer;
        width: 14px;
        height: 40px;
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: -14px;
        top: 50%;
        transform: translateY(-50%);

        .iconpark-icon {
            width: 12px;
            height: 12px;
            display: block;
        }
    }

    .empty {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .empty-img {
            display: block;
            width: 96px;
            height: 96px;
            margin-bottom: 16px;
        }

        span {
            color: rgba(0, 0, 0, 0.4);
            font-size: 12px;
            text-align: center;
        }
    }
}
</style>
<style lang="less">
.chat-delete-buttons-1 {
    .anticon {
        display: none;
    }

    .ant-popover-message-title {
        padding-left: 0;
    }

    .confirm-wrap {
        .title {
            font-size: 14px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.9);
            margin-bottom: 8px;
        }

        .cont {
            color: rgba(0, 0, 0, 0.6);
            font-size: 12px;
        }
    }

    .ant-popover-buttons {
        .ant-btn {
            border-radius: 16px;

            &:nth-child(1),
            &:hover:nth-child(1) {
                color: rgba(0, 0, 0, 0.9);
                background: rgba(235, 239, 244, 0.6);
                border-color: rgba(235, 239, 244, 0.6);
            }

            span {
                font-size: 12px;
                line-height: 14px;
            }
        }

        .ant-btn.ant-btn-primary {
            background: @primary-color;
            border-color: @primary-color;

            &:hover {
                background: @primary-color;
                border-color: @primary-color;
                color: #ffffff;
            }
        }
    }
}
</style>
